z<template>
  <section class="flex flex-col md:flex-row h-screen items-center">
    <div
      class="hidden lg:block w-full md:w-1/2 xl:w-2/3 h-screen items-center"
    >
      <div class="h-[100vh] bg-white flex justify-center place-items-center">
        <lottie
        :options="animationOptions"
        :class="[
          isMobile ? 'w-[100%] mt-10' : ''
        ]"
        class="mt-auto mb-auto"
        height="600"
        />
      </div>
    </div>

    <div
      class="bg-white w-full md:max-w-md lg:max-w-full md:mx-auto md:w-1/2 xl:w-1/3 h-screen px-6 lg:px-16 xl:px-12 flex items-center justify-center shadow-lg"
    >
      <div class="w-full h-100">

        <div class="w-full flex justify-center -mt-4 -mb-8">
          <img
            src="./../../assets/logo/logo-rs-bg.png"
            width="210"
            height="210"
            class="rounded-lg"
          >
        </div>

        <h1 class="text-xl md:text-2xl font-bold leading-tight mt-12">
          Entre com seu acesso
        </h1>

        <div id="form-fields" class="mt-6">
          <div class="relative">
            <label class="block text-gray-700 w-full text-start">Email</label>
            <input
              type="email"
              v-model="authStore.email"
              name="email"
              placeholder="Enter Email Address"
              class="w-full px-4 py-3 rounded-lg bg-gray-200 mt-0 border focus:border-blue-500 focus:bg-white focus:outline-none"
              autofocus
              autocomplete
              required
            />

            <span name="email" class="text-red-600 text-sm" />
          </div>

          <div class="mt-4 relative">
            <label class="block text-gray-700 w-full text-start">Senha</label>
            <input
              required
              v-model="authStore.password"
              name="password"
              type="password"
              @keyup.enter="signin"
              placeholder="Senha"
              minlength="3"
              class="w-full px-4 py-3 rounded-lg bg-gray-200 border focus:border-blue-500 focus:bg-white focus:outline-none"
            />

            <span name="password" class="text-red-600 text-sm" />
          </div>

          <button
            type="submit"
            @click.prevent="signin"
            class="w-full block bg-[#d20a0a] hover:bg-red-700 focus:bg-red-700 text-white font-inter font-semibold rounded-lg px-4 py-3 mt-6"
          >
            Entrar
          </button>
        </div>

        <hr class="my-6 border-gray-300 w-full" />
      </div>
    </div>
  </section>
</template>

<script setup>
import AuthService from './services/auth.service'
import router from '@/router'
import * as yup from './../../validator'
import { setFormFieldsError } from './../../helpers/formFieldsHandler'
import { showToast as toast } from '@/helpers/UseToasts'
import { permissionsRoute } from './lookups'
import { storeApp } from '@/store'
import { dataAuth } from './store'
import { onMounted, ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const authStore = dataAuth.state
const appStore = storeApp.state
const urouter = useRouter()
const uroute = useRoute()
const animationOptions = ref({
  animationData: require('@/assets/lotties/manager.json'),
  loop: true,
  autoplay: true
})

const isMobile = computed(() => window.innerWidth < 768)
const schema = yup.object().shape({
  email: yup.string().email().required().label('Email').max(35).min(11),
  password: yup.string().required().label('Senha').min(4)
})

onMounted(() => {
  appStore.showMenu = false

  // const token = uroute.query.access_token;
  // if (token) {
  //   return setStorageSocialLogin()
  // }
})

function setStorageSocialLogin () {
  localStorage.clear()

  storeApp.dispatch('showMenuUserLogged')
  storeApp.dispatch('setUserAuthenticated', true)
  sendNotification()

  const userString = uroute.query.user
  const user = userString ? JSON.parse(userString) : {}
  const token = uroute.query.access_token

  const userPermissions = user.permissions ? [...user.permissions].map((el) => el.key) : []

  // storage
  storeApp.dispatch('setUserName', {
    key: '__user_name',
    value: user?.name
  })

  storeApp.dispatch('setUserRole', {
    key: '__user_role',
    value: user?.function
  })

  storeApp.dispatch('setUserPhoto', {
    key: '__user_photo',
    value: user?.image_profile
  })

  storeApp.dispatch('setPermissionsData', {
    key: '__permissions',
    value: userPermissions
  })

  localStorage.__access = token
  localStorage.__uuid = user?.id

  storeApp.dispatch('setCompanyLogo', {
    key: '__company_logo',
    value: user?.companies?.photo ?? null
  })

  localStorage.__company_logo = user?.companies?.photo ?? null

  storeApp.dispatch('setCompanyName', {
    key: '__company_name',
    value: user?.companies?.name
  })

  localStorage.__company = user?.company_id

  appStore.accessToken = localStorage
  appStore.showMenu = true
  appStore.loading = false

  toast('Olá', 'Seja bem vindo', 'success')

  if (userPermissions) {
    const userPermissionsArray = localStorage
      .getItem('__permissions')
      .split(',')
    const matchedRoute = permissionsRoute.find((item) =>
      userPermissionsArray.includes(item.permission)
    )

    appStore.showMenu = true
    storeApp.dispatch('showMenuUserLogged')

    // if (matchedRoute) {
    //   router.push(matchedRoute.route);
    // } else {
    //   console.warn(
    //     "Nenhuma rota disponível para as permissões do usuário."
    //   );
    //   router.push("/error");
    // }
  }

  router.push('/home')
}

async function signin () {
  appStore.loading = true

  const errors = []
  await schema.validate(authStore, { abortEarly: false }).catch((err) => {
    err.inner.forEach((e) => {
      errors.push({
        name: e.path,
        msg: e.message
      })
    })
  })

  if (errors.length > 0) {
    appStore.loading = false
    setFormFieldsError(errors)
    return
  }

  await AuthService.login(authStore)
    .then((res) => {
      storeApp.dispatch('showMenuUserLogged')
      storeApp.dispatch('setUserAuthenticated', true)
      sendNotification()

      const userPermissions = [...res.data.user.permissions].map(
        (el) => el.key
      )

      // localStorage.clear()

      // storage
      storeApp.dispatch('setUserName', {
        key: '__user_name',
        value: res.data?.user?.name
      })

      storeApp.dispatch('setUserRole', {
        key: '__user_role',
        value: res.data?.user?.function
      })

      storeApp.dispatch('setUserPhoto', {
        key: '__user_photo',
        value: res.data?.user?.image_profile
      })

      storeApp.dispatch('setPermissionsData', {
        key: '__permissions',
        value: userPermissions
      })

      localStorage.__access = res.data?.access_token
      localStorage.__uuid = res.data?.user?.id

      storeApp.dispatch('setCompanyLogo', {
        key: '__company_logo',
        value: res.data?.user?.companies?.photo ?? null
      })

      localStorage.__company_logo = res.data?.user?.companies?.photo ?? null

      storeApp.dispatch('setCompanyName', {
        key: '__company_name',
        value: res.data?.user?.companies?.name
      })

      localStorage.__company = res.data?.user?.company_id

      appStore.accessToken = localStorage
      appStore.showMenu = true
      appStore.loading = false

      toast('Olá', 'Seja bem vindo', 'success')

      if (userPermissions) {
        const userPermissionsArray = localStorage
          .getItem('__permissions')
          .split(',')
        // const matchedRoute = permissionsRoute.find((item) =>
        //   userPermissionsArray.includes(item.permission)
        // );

        // if (matchedRoute) {
        //   router.push(matchedRoute.route);
        // } else {
        //   console.warn(
        //     "Nenhuma rota disponível para as permissões do usuário."
        //   );
        //   router.push("/error");
        // }
      }

      router.push({ name: 'home' })
    })
    .catch((err) => {
      appStore.loading = false
      appStore.showMenu = false

      if (err?.response?.data?.error && err?.response?.data?.status == 401) {
        return toast('Aviso', err?.response?.data?.message, 'error')
      }

      return toast('Aviso', 'Algo deu errado com seu acesso', 'error')
    })
}

const sendNotification = () => {
  // AuthService.sendNotification()
  // AuthService.sendAlertAndWarningNotification()
  // AuthService.sendTrainingsNotification()
}

</script>

<style lang="scss" scoped>
/* From Uiverse.io by Yaya12085 */
#button-google {
  max-width: 320px;
  display: flex;
  padding: 0.5rem 1.4rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  vertical-align: middle;
  align-items: center;
  border-radius: 0.5rem;
  border: 1px solid rgba(0, 0, 0, 0.25);
  gap: 0.75rem;
  color: rgb(65, 63, 63);
  background-color: #fff;
  cursor: pointer;
  transition: all .6s ease;
}

.button svg {
  height: 24px;
}

#button-google:hover {
  transform: scale(1.02);
}
</style>
